import React, { useState, useEffect, lazy, Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import { LanguageProvider } from './LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import SEO from './components/SEO';
import { initPerformanceOptimizations } from './utils/performance';

// Lazy load non-critical components for better performance
const Services = lazy(() => import('./components/Services'));
const Pricing = lazy(() => import('./components/Pricing'));
const Features = lazy(() => import('./components/Features'));
const Contact = lazy(() => import('./components/Contact'));
const Footer = lazy(() => import('./components/Footer'));
const TermsOfService = lazy(() => import('./components/TermsOfService'));
const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy'));

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    // Initialize performance optimizations
    initPerformanceOptimizations();
    
    // Set HTML lang attribute based on browser language
    const browserLang = navigator.language.toLowerCase();
    const isbulgarian = browserLang.startsWith('bg');
    document.documentElement.lang = isbulgarian ? 'bg' : 'en';
    
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1);
      if (hash === 'terms') {
        setCurrentPage('terms');
      } else if (hash === 'privacy') {
        setCurrentPage('privacy');
      } else {
        setCurrentPage('home');
      }
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  const LoadingFallback = () => (
    <div style={{ minHeight: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div>Loading...</div>
    </div>
  );

  return (
    <HelmetProvider>
      <LanguageProvider>
        <div className="App">
          <SEO />
          <Header />
          <Suspense fallback={<LoadingFallback />}>
            {currentPage === 'home' && (
              <>
                <Hero />
                <Services />
                <Pricing />
                <Features />
                <Contact />
              </>
            )}
            {currentPage === 'terms' && <TermsOfService />}
            {currentPage === 'privacy' && <PrivacyPolicy />}
            <Footer />
          </Suspense>
        </div>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;

